import { render, staticRenderFns } from "./policyInfo.vue?vue&type=template&id=34638ec5&scoped=true"
import script from "./policyInfo.vue?vue&type=script&lang=js"
export * from "./policyInfo.vue?vue&type=script&lang=js"
import style0 from "./policyInfo.vue?vue&type=style&index=0&id=34638ec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34638ec5",
  null
  
)

export default component.exports